var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('div',{staticClass:"collection-headline"},[_c('div',{staticClass:"grid-block grid grid-cols-4 md:grid-cols-12 col-gap-16 md:col-gap-24"},[_c('div',{staticClass:"col-span-4 md:col-span-8 md:col-start-3"},[_c('Headline',{attrs:{"globalSet":_vm.globalSet}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }